import numeral from "numeral";
import { isValid, format } from "date-fns";

export function formatDate(value, customFormat) {
  if (isValid(value)) {
    return format(value, customFormat ? customFormat : "yyyy-M-dd");
  } else {
    return "-";
  }
}

export function formatNumber(value, format) {
  return numeral(value).format(format ? format : "0");
}
